import React from 'react';
import { X } from 'lucide-react';
import { styles } from '../styles/styles.js';

const AddTaskModal = ({
    showModal,
    setShowModal,
    newTask,
    setNewTask,
    workers,
    onAddTask
}) => {
    if (!showModal) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onAddTask();
    };
// 
    return (
        <div style={styles.modal}>
            <div style={styles.modalContent}>
                <div style={styles.modalHeader}>
                    <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#111827' }}>Add New Task</h2>
                    <button
                        onClick={() => setShowModal(false)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280' }}
                    >
                        <X size={24} />
                    </button>
                </div>

                <p style={{ color: '#6b7280', marginBottom: '1rem' }}>Create a new housekeeping task and assign it to a worker.</p>

                <form onSubmit={handleSubmit}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        <div style={styles.formGroup}>
                            <label style={styles.formLabel}>Task Title</label>
                            <input
                                type="text"
                                value={newTask.title}
                                onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
                                placeholder="e.g., Clean Room 101"
                                style={styles.formInput}
                                required
                            />
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.formLabel}>Description</label>
                            <textarea
                                value={newTask.description}
                                onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
                                placeholder="Detailed task description..."
                                rows="2"
                                style={styles.formInput}
                            ></textarea>
                        </div>

                        <div style={styles.formGrid}>
                            <div>
                                <label style={styles.formLabel}>Room/Location</label>
                                <input
                                    type="text"
                                    value={newTask.location}
                                    onChange={(e) => setNewTask({ ...newTask, location: e.target.value })}
                                    placeholder="Room 101"
                                    style={styles.formInput}
                                    required
                                />
                            </div>

                            <div>
                                <label style={styles.formLabel}>Est. Time (min)</label>
                                <input
                                    type="number"
                                    value={newTask.estimatedTime}
                                    onChange={(e) => setNewTask({ ...newTask, estimatedTime: parseInt(e.target.value) || 30 })}
                                    min="5"
                                    max="480"
                                    style={styles.formInput}
                                />
                            </div>
                        </div>

                        <div style={styles.formGrid}>
                            <div>
                                <label style={styles.formLabel}>Priority</label>
                                <select
                                    value={newTask.priority}
                                    onChange={(e) => setNewTask({ ...newTask, priority: e.target.value })}
                                    style={styles.formInput}
                                >
                                    <option value="low">Low</option>
                                    <option value="medium">Medium</option>
                                    <option value="high">High</option>
                                </select>
                            </div>

                            <div>
                                <label style={styles.formLabel}>Due Date</label>
                                <input
                                    type="date"
                                    value={newTask.dueDate}
                                    onChange={(e) => setNewTask({ ...newTask, dueDate: e.target.value })}
                                    style={styles.formInput}
                                    required
                                />
                            </div>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.formLabel}>Assign To</label>
                            <select
                                value={newTask.assignedTo}
                                onChange={(e) => setNewTask({ ...newTask, assignedTo: e.target.value })}
                                style={styles.formInput}
                                required
                            >
                                <option value="">Select a worker</option>
                                {workers.map(worker => (
                                    <option key={worker.id} value={worker.id}>
                                        {worker.name} - {worker.role}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div style={styles.btnGroup}>
                        <button
                            type="button"
                            onClick={() => setShowModal(false)}
                            style={{ ...styles.btn, ...styles.btnSecondary }}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={!newTask.title || !newTask.assignedTo || !newTask.location || !newTask.dueDate}
                            style={{
                                ...styles.btn,
                                ...styles.btnPrimary,
                                opacity: (!newTask.title || !newTask.assignedTo || !newTask.location || !newTask.dueDate) ? 0.5 : 1,
                                cursor: (!newTask.title || !newTask.assignedTo || !newTask.location || !newTask.dueDate) ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Add Task
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddTaskModal;